import React from "react";
import { Layout, Typography } from "antd";
import { withTranslation } from "react-i18next";

import { WHITE_GRAY } from "../constant/colors";

const { Footer } = Layout;
const { Text } = Typography;

const MainFooterComponent = ({ t }) => (
  <Footer
    style={{
      position: "sticky",
      bottom: "0",
      width: "100%",
      backgroundColor: "white",
      borderTop: `2px solid ${WHITE_GRAY}`
    }}
  >
    <Text>{t("footer", { year: new Date().getFullYear() })}</Text>
  </Footer>
);

const MainFooter = withTranslation()(MainFooterComponent);
export { MainFooter };
